module.exports = __webpack_public_path__ + "img/11.ae833961.png";